<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="640"
  >
    <v-card>
      <div :class="$style.host">
        <img
          alt="Logo"
          :src="$assets.icon('checkmark.svg')"
          :class="$style.icon"
        >
        <div :class="$style.headline">
          <span>Thank you</span>
        </div>
        <div :class="$style.description">
          <span>
            Your registration has been submitted successfully.
            <br>
            A member of our team will be in touch with you soon.
          </span>
        </div>
        <v-btn
          color="#203e52"
          type="submit"
          :class="$style.button"
          @click="close"
        >
          Close
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RegistrationSuccess',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  methods: {
    close() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" module>
.host {
  padding: 60px 15px;
  text-align: center;

  .icon {
    width: 100%;
    max-width: 80px;
  }

  .headline {
    margin-top: 25px;

    > span {
      @include font-rubik-grey(32px, 500, 38px);
    }
  }

  .description {
    margin-top: 15px;

    > span {
      @include font-open-sans-grey;
    }
  }

  .button {
    margin-top: 25px;
    width: 100%;
    max-width: 240px;
    min-height: 50px;

    > span {
      @include font-rubik-white(18px, 500, 22px, uppercase);
    }
  }
}
</style>
